// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import Reception from "../views/Reception.vue";
import Users from "../views/Users.vue";
import TracingSample from "@/components/reception/tracingSample/TracingSample.vue";
import Farms from "../views/Farms.vue";

export default [
  {
    path: "/reception/:page/:tab",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Reception",
        component: Reception,
        meta: {
          title: "Recepción",
        },
      },
    ],
  },
  {
    path: "/tracing/:id",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Trazabilidad muestra",
        component: TracingSample,
        meta: {
          title: "Trazabilidad muestra",
        },
      },
    ],
  },
  {
    path: "/users",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Usuarios",
        component: Users,
        meta: {
          title: "Usuarios",
        },
      },
    ],
  },
  {
    path: "/farms",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Agrícolas",
        component: Farms,
        meta: {
          title: "Agrícolas",
        },
      },
    ],
  },
];
